// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Mem$Showside from "../utils/Mem.bs.js";
import * as Product$Showside from "./Product.bs.js";
import * as Category$Showside from "./Category.bs.js";
import * as UniqueArray$Showside from "../utils/UniqueArray.bs.js";
function makeMediaChildFromCategory(containerWidth, containerHeight, originalWidth, originalHeight, category) {
  var products = Category$Showside.getProducts(category);
  var imageHotspots = Category$Showside.getImageHotspots(category);
  var title = category.title;
  var title$1 = title.trim() !== "" && category.showTitle ? title : undefined;
  var description = category.description;
  var link = Category$Showside.Link.getCardFallbackLink(category);
  var match = category.card;
  var match$1;
  switch (match.TAG | 0) {
    case /* ImageLinkCard */0:
      match$1 = ["image", match._0.imageUrl];
      break;
    case /* VideoLinkCard */1:
      match$1 = ["video", match._0.videoUrl];
      break;
    case /* ImageCard */2:
      match$1 = ["image", match._0.imageUrl];
      break;
    case /* VideoCard */3:
      match$1 = ["video", match._0.videoUrl];
      break;
    case /* MedialessCard */4:
    case /* MedialessLinkCard */5:
      match$1 = ["video", undefined];
      break;
    case /* ImageDisplayCard */6:
      match$1 = ["image", match._0.imageUrl];
      break;
    case /* VideoDisplayCard */7:
      match$1 = ["video", match._0.videoUrl];
      break;
  }
  var kind = match$1[0];
  var overlayKind = kind === "image" && Belt_Option.isSome(imageHotspots) ? "image" : "video";
  var card = category.card;
  var poster;
  switch (card.TAG | 0) {
    case /* ImageLinkCard */0:
      poster = card._0.imageUrl;
      break;
    case /* VideoLinkCard */1:
      poster = card._0.fallbackImageUrl;
      break;
    case /* ImageCard */2:
      poster = card._0.imageUrl;
      break;
    case /* VideoCard */3:
      poster = card._0.fallbackImageUrl;
      break;
    case /* MedialessCard */4:
    case /* MedialessLinkCard */5:
      poster = undefined;
      break;
    case /* ImageDisplayCard */6:
      poster = card._0.imageUrl;
      break;
    case /* VideoDisplayCard */7:
      poster = card._0.fallbackImageUrl;
      break;
  }
  var match$2 = Category$Showside.getCategoryImageSize(category);
  var originalWidth$1 = Belt_Option.getWithDefault(match$2[0], originalWidth);
  var originalHeight$1 = Belt_Option.getWithDefault(match$2[1], originalHeight);
  return {
    id: category.id,
    kind: kind,
    title: title$1,
    showTitle: category.showTitle,
    description: description,
    link: link,
    overlayKind: overlayKind,
    originalWidth: originalWidth$1,
    originalHeight: originalHeight$1,
    src: Belt_Option.getWithDefault(match$1[1], ""),
    fallbackImageUrl: poster,
    pins: Belt_Option.getWithDefault(imageHotspots, Belt_Array.map(products, function (product) {
      return {
        id: product.productId,
        x: 0,
        y: 0,
        productId: product.productId,
        variantId: product.variantId,
        visible: true
      };
    }))
  };
}
function makeMediaChildFromMedia(media) {
  var match = media.kind;
  return {
    id: media.id,
    kind: typeof match === "object" || match !== "video" ? "image" : "video",
    title: media.title,
    showTitle: media.showTitle,
    description: media.description,
    link: media.link,
    overlayKind: media.overlayKind,
    originalWidth: media.originalWidth,
    originalHeight: media.originalHeight,
    src: media.src,
    fallbackImageUrl: media.fallbackImageUrl,
    pins: media.pins
  };
}
function makeMediaFromMediaChild(mediaChild) {
  var match = mediaChild.kind;
  return {
    order: 0,
    id: mediaChild.id,
    kind: match === "image" ? "image" : "video",
    title: mediaChild.title,
    showTitle: mediaChild.showTitle,
    description: mediaChild.description,
    link: mediaChild.link,
    overlayKind: mediaChild.overlayKind,
    originalWidth: mediaChild.originalWidth,
    originalHeight: mediaChild.originalHeight,
    src: mediaChild.src,
    fallbackImageUrl: mediaChild.fallbackImageUrl,
    pins: mediaChild.pins
  };
}
function getMediaKind(originalWidth, originalHeight, containerWidth, containerHeight, isQuickViewStories, category) {
  var match = category.card;
  var kind;
  switch (match.TAG | 0) {
    case /* VideoLinkCard */1:
    case /* VideoCard */3:
    case /* MedialessCard */4:
    case /* MedialessLinkCard */5:
    case /* VideoDisplayCard */7:
      kind = "video";
      break;
    default:
      kind = "image";
  }
  var match$1 = category.categoryType;
  var kind$1;
  if (typeof match$1 === "number" || match$1.TAG !== /* QuickView */2) {
    kind$1 = kind;
  } else {
    var children = match$1._0.children;
    kind$1 = children.length !== 0 ? {
      NAME: "album",
      VAL: Belt_Array.map(children, function (param) {
        return makeMediaChildFromCategory(containerWidth, containerHeight, originalWidth, originalHeight, param);
      })
    } : isQuickViewStories ? {
      NAME: "album",
      VAL: [makeMediaChildFromCategory(containerWidth, containerHeight, originalWidth, originalHeight, category)]
    } : kind;
  }
  if (Category$Showside.isQuickViewStoriesEnabled(category) && (kind$1 === "image" || kind$1 === "video")) {
    return {
      NAME: "album",
      VAL: [makeMediaChildFromCategory(Caml_option.some(containerWidth), Caml_option.some(containerHeight), originalWidth, originalHeight, category)]
    };
  } else {
    return kind$1;
  }
}
function makeMediaFromCategory(containerWidth, containerHeight, order, parentCategory, category) {
  var match = category.card;
  var mediaUrl;
  switch (match.TAG | 0) {
    case /* ImageLinkCard */0:
      mediaUrl = match._0.imageUrl;
      break;
    case /* VideoLinkCard */1:
      mediaUrl = match._0.videoUrl;
      break;
    case /* ImageCard */2:
      mediaUrl = match._0.imageUrl;
      break;
    case /* VideoCard */3:
      mediaUrl = match._0.videoUrl;
      break;
    case /* MedialessCard */4:
    case /* MedialessLinkCard */5:
      mediaUrl = undefined;
      break;
    case /* ImageDisplayCard */6:
      mediaUrl = match._0.imageUrl;
      break;
    case /* VideoDisplayCard */7:
      mediaUrl = match._0.videoUrl;
      break;
  }
  var isQuickViewStories = Belt_Option.mapWithDefault(parentCategory, false, Category$Showside.isQuickViewStoriesEnabled);
  var match$1 = Category$Showside.getCategoryImageSize(category);
  var originalWidth = Belt_Option.mapWithDefault(match$1[0], 1440, function (w) {
    if (w === 0) {
      return 1440;
    } else {
      return w;
    }
  });
  var originalHeight = Belt_Option.mapWithDefault(match$1[1], 1080, function (h) {
    if (h === 0) {
      return 1080;
    } else {
      return h;
    }
  });
  var kind = getMediaKind(originalWidth, originalHeight, containerWidth, containerHeight, isQuickViewStories, category);
  var products = typeof kind === "object" ? Belt_Array.reduce(kind.VAL, [], function (acc, child) {
    return Belt_Array.concat(acc, Belt_Array.map(child.pins, function (pin) {
      return {
        id: pin.id,
        productId: pin.productId,
        variantId: pin.variantId
      };
    }));
  }) : kind === "placeholder" ? [] : Category$Showside.getProducts(category);
  var title = category.title;
  var title$1 = title.trim() !== "" ? title : undefined;
  var description = category.description;
  var link = Category$Showside.Link.getCardFallbackLink(category);
  var imageHotspots = typeof kind === "object" ? Belt_Array.concatMany(Belt_Array.map(kind.VAL, function (media) {
    return media.pins;
  })) : kind === "placeholder" ? undefined : Category$Showside.getImageHotspots(category);
  var overlayKind = kind === "image" && Belt_Option.isSome(imageHotspots) ? "image" : "video";
  var card = category.card;
  var poster;
  switch (card.TAG | 0) {
    case /* ImageLinkCard */0:
      poster = card._0.imageUrl;
      break;
    case /* VideoLinkCard */1:
      poster = card._0.fallbackImageUrl;
      break;
    case /* ImageCard */2:
      poster = card._0.imageUrl;
      break;
    case /* VideoCard */3:
      poster = card._0.fallbackImageUrl;
      break;
    case /* MedialessCard */4:
    case /* MedialessLinkCard */5:
      poster = undefined;
      break;
    case /* ImageDisplayCard */6:
      poster = card._0.imageUrl;
      break;
    case /* VideoDisplayCard */7:
      poster = card._0.fallbackImageUrl;
      break;
  }
  var match$2 = typeof kind === "object" ? Belt_Option.getWithDefault(Belt_Option.map(Belt_Array.get(kind.VAL, 0), function (firstChild) {
    return [firstChild.originalWidth, firstChild.originalHeight];
  }), [originalWidth, originalHeight]) : [originalWidth, originalHeight];
  return {
    order: order,
    id: category.id,
    kind: kind,
    title: title$1,
    showTitle: category.showTitle,
    description: description,
    link: link,
    overlayKind: overlayKind,
    originalWidth: match$2[0],
    originalHeight: match$2[1],
    src: Belt_Option.getWithDefault(mediaUrl, ""),
    fallbackImageUrl: poster,
    pins: Belt_Option.getWithDefault(imageHotspots, Belt_Array.map(products, function (product) {
      return {
        id: product.productId,
        x: 0,
        y: 0,
        productId: product.productId,
        variantId: product.variantId,
        visible: true
      };
    }))
  };
}
function getAlbumMediaId(media) {
  var match = media.kind;
  if (typeof match === "object") {
    return Belt_Option.map(Belt_Array.get(match.VAL, 0), function (child) {
      return child.id;
    });
  }
}
var productsInMedia = Mem$Showside.mem(function (config, media) {
  return Belt_Array.keepMap(media.pins, function (pin) {
    return Product$Showside.getProductById(config.products, pin.productId);
  });
});
var productVariantsInMedia = Mem$Showside.mem(function (hideOutOfStock, config, media, defaultVariantSelector) {
  return Belt_Array.keepMap(media.pins, function (pin) {
    return Belt_Option.map(Product$Showside.getProductById(config.products, pin.productId), function (product) {
      var variant = Product$Showside.getInitialDisplayVariant(hideOutOfStock, pin.variantId, defaultVariantSelector, product);
      return [product, variant];
    });
  });
});
var productsInMediaChild = Mem$Showside.mem(function (config, media) {
  return Belt_Array.keepMap(media.pins, function (pin) {
    return Product$Showside.getProductById(config.products, pin.productId);
  });
});
var productsInPage = Mem$Showside.mem(function (config, excludeMedia) {
  return Belt_Array.reduce(config.media, [], function (result, media) {
    if (media === excludeMedia) {
      return result;
    } else {
      return Belt_Array.concat(result, Curry._2(productsInMedia, config, media));
    }
  });
});
var mediaIdMap = Mem$Showside.mem(function (media) {
  return Js_dict.fromArray(Belt_Array.map(media, function (m) {
    return [m.id, m];
  }));
});
function mediaById(config, id) {
  return Js_dict.get(Curry._1(mediaIdMap, config.media), id);
}
function makePlaceholderMedia(order) {
  return {
    order: order,
    id: String(order),
    kind: "placeholder",
    title: undefined,
    showTitle: false,
    description: undefined,
    link: undefined,
    overlayKind: undefined,
    originalWidth: 1440,
    originalHeight: 1080,
    src: "",
    fallbackImageUrl: undefined,
    pins: []
  };
}
function dedupById(__x) {
  return UniqueArray$Showside.getUnique(__x, function (media) {
    return media.id;
  });
}
var defaultWidth = 1440;
var defaultHeight = 1080;
export { defaultWidth, defaultHeight, makeMediaChildFromCategory, makeMediaChildFromMedia, makeMediaFromMediaChild, getMediaKind, makeMediaFromCategory, getAlbumMediaId, productsInMedia, productVariantsInMedia, productsInMediaChild, productsInPage, mediaIdMap, mediaById, makePlaceholderMedia, dedupById };
/* productsInMedia Not a pure module */